import { render, staticRenderFns } from "./ResumoPix.vue?vue&type=template&id=3230e2ec"
import script from "./ResumoPix.vue?vue&type=script&lang=ts"
export * from "./ResumoPix.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports